import { useNavigate } from '@tanstack/react-router';

import { SupplierCompanyMessage } from '../../../../types/SupplierCompanyMessage';
import { IconCornerDownRight } from '../../icons/cdl/CornerDownRight';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

interface CompanyDetailProps {
    supplier: SupplierCompanyMessage;
    value: string;
    isChildren: boolean;
}

export const CommandSupplierCompanyDetail = (props: CompanyDetailProps) => {
    const { setOpen } = useShortcutMenu();
    const navigate = useNavigate();

    const onCompanySelect = (id: string) => {
        navigate({
            to: '/supplier-groups/$groupId/companies/$companyId',
            params: { groupId: props.supplier.supplierGroupId, companyId: id },
        });
        setOpen(false);
    };

    return (
        <CommandItem
            value={props.value}
            onSelect={() => onCompanySelect(props.supplier.id)}
            Icon={props.isChildren ? IconCornerDownRight : undefined}
        >
            {props.supplier.internalName || props.supplier.name}
        </CommandItem>
    );
};
